import { clientProfileRoutes, staticRoutes } from '@atlas/routing';

export const authProtectedRoutes = [
  `/${clientProfileRoutes.achievements}`,
  staticRoutes.tournaments,
];

export const transformNavigationLink = link => {
  if (link !== `/${clientProfileRoutes.achievements}`) return link;
  return `?cmd=${clientProfileRoutes.achievements}`;
};
